import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangaData';

export default function Footer() {
  const quickLinks = [
    { name: '官方入口', path: '/article/1' },
    { name: '注册登录', path: '/article/2' },
    { name: '使用教程', path: '/article/4' },
    { name: '常见问题', path: '/article/5' },
    { name: '关于我们', path: '/about' },
  ];

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                禁漫天
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              国内领先的漫画阅读平台，海量正版漫画资源，畅快阅读体验。让每一个人都能轻松享受漫画的乐趣。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2.5 flex flex-wrap gap-x-6 gap-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                support@jinmantian.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-weibo-line text-xs"></i>
                </div>
                @禁漫天官方
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line text-xs"></i>
                </div>
                周一至周日 9:00 - 21:00
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-700/50">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 禁漫天 版权所有 | 本网站仅供信息参考与使用指南
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}